import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { TemplatesRepository } from '@core/repositories/templates.repository';
import { Template } from '@shared/interfaces/template';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiTemplatesRepository implements TemplatesRepository {
  public url = this.appConfig.URL + '/amlcontrol/v1/templates/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(template: Template): Observable<any> {
    const data = {
      data: {
        id: template.id,
        type: 'Template',
        attributes: {
          name: template.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(template: Template): Observable<any> {
    const data = {
      data: {
        id: template.id,
        type: 'Template',
        attributes: {
          name: template.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
